
define('text!plugins/templates/employment_moreInfo_table.html',[],function () { return '<html xmlns="http://www.w3.org/1999/xhtml">\n<head>\n  <title>Hourly Wage table</title>\n</head>\n<body>\n\n          {{data}}\n\n\t</table>\n\n</body>\n</html>\n';});

